import script from "./MainFooterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFooterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MainFooterComponent.vue?vue&type=style&index=0&id=180585dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180585dc"]])

export default __exports__